import React from 'react';
import './Contact.css';


const Contact = function(props){
  return (
    <div>
      <div id="contact" className="space-sm"></div>

      <div className="contact">
        <div className="left">
        <div id="headerAddress"> <span>  </span>
      <span className="contacttext">
                    <a href="http://www.aviz.fr/" target="_blank" rel="noopener noreferrer">Aviz</a> -
                    <a href="http://www.inria.fr" target="_blank" rel="noopener noreferrer">INRIA</a><br />
                        Bat 660, Université Paris-Sud<br />
                        91405 Orsay Cedex, France <br />
                  </span>
      </div>
      </div>
      <div className="right">
        <div id="headerEmail">
          <span className="contacttext">
                    paola [dot] valdivia [at] inria [dot] fr
                  </span>
        </div>

        {/*<div id="headerPhone"> <span> phone: </span>*/}
          {/*<span className="contacttext">*/}
                    {/*+55 16 3373 9676*/}
              {/*</span>*/}
        {/*</div>*/}
      </div>
      </div>
      <div className="space-sm"></div>
    </div>
  );
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js